import config from "../../config";
import $axios from "@/plugins/axios";

const url = `${config.baseUrl}article`;

export class ArticleService {
    getPublished (num, page, size) {
        return $axios(`${url}/published/${num}/${page}/${size}`).then((res) => res.data);
    }
    getPublishedById (id) {
        return $axios(`${url}/published/${id}`).then((res) => res.data);
    }
    getArticles (num, page, size) {
        return $axios.get(`${url}/${num}/${page}/${size}`).then((res) => res.data);
    }
}
